import RatingCategories from './RatingCategories.vue'

export default RatingCategories
